if (!customElements.get('lookbook-slider')) {
  customElements.define(
    'lookbook-slider',
    class LookbookSlider extends HTMLElement {
      constructor() {
        super();

        this.init = this.init.bind(this);
        this.handleBlockSelect = this.handleBlockSelect.bind(this);
      }
      connectedCallback() {
        this.selectors = {
          sliderWrapper: '.lookbook-slider__items',
          nextEl: '.swiper-button-next',
          prevEl: '.swiper-button-prev',
          pagination: '.swiper-pagination',
        };

        this.classes = {
          swiper: 'swiper',
          swiperWrapper: 'swiper-wrapper',
        };

        this.sectionId = this.dataset.sectionId;
        this.section = this.closest(`.section-${this.sectionId}`);
        this.sliderWrapper = this.querySelector(this.selectors.sliderWrapper);
        this.paginationType = this.dataset.paginationType || 'bullets';
        this.enableSlider = this.dataset.enableSlider === 'true';
        this.enableSwiperMobile = this.dataset.swipeMobile === 'true';

        this.sliderInstance = false;

        if (!this.enableSlider) return;
        this.mobileMediaQuery = window.matchMedia(FoxTheme.config.mediaQueryMobile);
        this.mobileMediaQuery.addEventListener('change', this.init);
        this.init();

        if (Shopify.designMode) {
          document.addEventListener('shopify:block:select', this.handleBlockSelect);
        }
      }

      disconnectedCallback() {
        if (this.mobileMediaQuery) {
          this.mobileMediaQuery.removeEventListener('change', this.init);
        }
        document.removeEventListener('shopify:block:select', this.handleBlockSelect);
        this.destroySlider();
      }

      init() {
        if (FoxTheme.config.mqlMobile && !this.enableSwiperMobile) {
          this.destroySlider();
        } else {
          this.initSlider();
        }

        this.calculateItemsWidth();
      }

      initSlider() {
        this.sliderOptions = {
          slidesPerView: 'auto',
          navigation: {
            nextEl: this.section.querySelector(this.selectors.nextEl),
            prevEl: this.section.querySelector(this.selectors.prevEl),
          },
          pagination: {
            el: this.section.querySelector(this.selectors.pagination),
            type: this.paginationType,
          },
          loop: false,
          threshold: 2,
          watchOverflow: true,
          mousewheel: {
            enabled: true,
            forceToAxis: true,
          },
          watchSlidesProgress: true,
        };

        if (typeof this.sliderInstance !== 'object') {
          this.classList.add(this.classes.swiper);
          this.sliderWrapper.classList.add(this.classes.swiperWrapper);
          this.sliderInstance = new window.FoxTheme.Carousel(this, this.sliderOptions, [FoxTheme.Swiper.Mousewheel]);
          this.sliderInstance.init();

          // const focusableElements = FoxTheme.a11y.getFocusableElements(this);

          // focusableElements.forEach((element) => {
          //   element.addEventListener('focusin', () => {
          //     const slide = element.closest('.swiper-slide');
          //     this.sliderInstance.slider.slideTo(this.sliderInstance.slider.slides.indexOf(slide));
          //   });
          // });
        }
      }

      destroySlider() {
        this.classList.remove(this.classes.swiper);
        this.sliderWrapper.classList.remove(this.classes.swiperWrapper);
        if (typeof this.sliderInstance !== 'object') return;
        this.sliderInstance.slider.destroy();
        this.sliderInstance = false;
      }

      calculateItemsWidth() {
        Array.from(this.sliderWrapper.children).forEach((item) => {
          const width = item.dataset.width;
          const widthMobile = item.dataset.widthMobile;
          item.style.setProperty('--item-width', width);
          item.style.setProperty('--item-width-mobile', widthMobile);
        });
      }

      handleBlockSelect(event) {
        if (!event.detail || event.detail.sectionId !== this.sectionId) return;
        if (typeof this.sliderInstance !== 'object' || !this.sliderInstance.slider) return;

        const index = Number(event.target.dataset.index);
        if (Number.isNaN(index)) return;

        this.sliderInstance.slider.slideTo(index);
      }
    }
  );
}

if (!customElements.get('lookbook-scroll-progress-bar')) {
  customElements.define(
    'lookbook-scroll-progress-bar',
    class LookbookScrollProgressBar extends ScrollProgressBar {
      get totalWidth() {
        this.allChildren = this.target.children;

        let totalWidth = 0;
        [...this.allChildren].forEach((child) => {
          totalWidth += child.offsetWidth;
        });

        return totalWidth;
      }
    }
  );
}
